<div class="list-page">
  <app-asiakas-otsikko otsikko="Pankkiyhteydet" paluuUrl="/asiakkaat" [asiakas]="asiakas()"></app-asiakas-otsikko>

  <mat-tab-group>
    <mat-tab label="Valtuutukset">
      <div class="wrapper">
        @if (kirjanpitajaOnDevaajaObservable | async) {
          <div style="padding-top: 20px" class="ng-star-inserted">
            <h3 style="margin: 0">Urit</h3>
            <div style="padding-top: 1em; padding-left: 1em; padding-right: 1em">
              Valtuutuksen data: <a [href]="consentUrlObservable | async" target="_blank">{{ consentUriObservable | async }}</a>
            </div>
          </div>
        }

        <div class="title">Asiakkaan valtuutus</div>

        @if (consentHtmlObservable | async; as consent) {
          <div [innerHTML]="consent"></div>
        } @else {
          Valtuutusta ladataan...
        }

        @if (historianMaaraObservable | async; as historianMaara) {
          <div class="title">Valtuutuksen historia ({{ historianMaara }} viimeistä)</div>
          <mat-radio-group (change)="historianMaaraChanged($event.value)" name="amnt" [value]="'' + historianMaara">
            <mat-radio-button value="50">50</mat-radio-button>
            <mat-radio-button value="100">100</mat-radio-button>
            <mat-radio-button value="500">500</mat-radio-button>
            <mat-radio-button value="1000">1000</mat-radio-button>
          </mat-radio-group>
        }

        <table>
          @for (historia of logsObservable | async; track historia) {
            <tr style="border-bottom: 1px solid gray">
              <td>{{ historia.source }}</td>
              <td>{{ historia.changedTime | ltimestamptimel: 'fi' }}</td>
              <td>{{ historia.changedReason }}</td>
              <td>{{ historia.details }}</td>
            </tr>
          }
        </table>
      </div>
    </mat-tab>
    <mat-tab label="Hae tapahtumat Holvista">
      <div app-holvi-transactions></div>
    </mat-tab>
    <mat-tab label="Hae tapahtumat Aiiasta">
      <div app-aiia-tilitapahtumat></div>
    </mat-tab>
    <mat-tab label="Hae tapahtumat Enable Bankingista">
      <div app-enable-banking-tilitapahtumat></div>
    </mat-tab>
    <mat-tab label="Aiia työt">
      <div app-aiia-tyohistoriat></div>
    </mat-tab>
  </mat-tab-group>
</div>
